module.exports = __webpack_public_path__ + "static/media/avatar.47305402.png";